import React from 'react'
import { useLang } from '../../hooks';

const AbsatAppsListItem = ({ app, user, onRedirect }) => {
    const {langSelected } = useLang();
    const _tenant = JSON.parse(localStorage.getItem('tenant'))?.username || window.location.pathname.split('/').filter(Boolean)[0];
    const _token = localStorage.getItem('token');
    const normalizedBaseUrl = String(app?.baseUrl || '').replace(/\/+$/, '');
    const appTitle = langSelected.value==="ar" ? app?.titleAr : app?.titleEn
    const appNameText = `${app?.name || ""} ${app?.titleAr || ""} ${app?.titleEn || ""}`.toLowerCase();
    const isSupportApp =
        appNameText.includes("support") ||
        appNameText.includes("الدعم") ||
        (normalizedBaseUrl.includes("support.absat-erp.com") && !normalizedBaseUrl.includes("support-admin.absat-erp.com"));
    const baseUrlForNavigate =
        isSupportApp && user?.supportAdminEnabled === true
            ? "https://support-admin.absat-erp.com"
            : normalizedBaseUrl;
    const _urlNavigate = app.status ==='done' && baseUrlForNavigate && _tenant && _token
        ? `${baseUrlForNavigate}/${_tenant}/token/${encodeURIComponent(_token)}`
        : '#';
    const isSettingsApp = appNameText.includes("setting") || appNameText.includes("إعداد") || appNameText.includes("اعداد");
    const iconSrc = app?.icon || (isSettingsApp ? "/assets/icons/settings.png" : app?.img);
    const isAllowed = app.status === "done";
    const shouldRender = user?.my_apps && user?.my_apps?.length > 0 ? user?.my_apps?.includes(app?._id) : true;
    const handleRedirect = () => {
        if (!isAllowed || !onRedirect) return;
        onRedirect(appTitle || app?.name, _urlNavigate);
    };
    return (
        <>
        { 
            shouldRender ? (
                <button
                    type="button"
                    onClick={handleRedirect}
                    disabled={!isAllowed}
                    className={
                        isAllowed
                        ? "category py-5 hover:bg-violet-50 h-[110px] transition-[0.7s] border border-[#B8AAEB] rounded-md flex flex-col justify-center items-center text-center gap-1 w-full"
                        : "category py-5 hover:cursor-not-allowed h-[110px] transition-[0.7s] border border-[#B8AAEB] rounded-md flex flex-col justify-center items-center text-center gap-1 w-full opacity-60 cursor-not-allowed"
                    }
                >
                    <img
                        src={iconSrc}
                        className={isAllowed ? "max-w-14" : "max-w-10"}
                        alt={appTitle || app?.name || 'app'}
                        style={
                            isSettingsApp
                                ? {
                                      filter:
                                          "brightness(0) saturate(100%) invert(14%) sepia(38%) saturate(1840%) hue-rotate(223deg) brightness(86%) contrast(96%)",
                                  }
                                : undefined
                        }
                    />
                    <h3 className="font-bold text-[17px] text-[#251658]">{appTitle}</h3>
                </button>
            ) : null
        }
        </>
    )
}

export default AbsatAppsListItem
